import {
  OAuthProvider,
  GoogleAuthProvider,
  createUserWithEmailAndPassword,
  onAuthStateChanged,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
  signInWithPopup,
  signOut,
  type Unsubscribe,
  type User,
} from "firebase/auth";
import { getFirebaseServices } from "./firebase";

export type AuthObserver = (user: User | null) => void;

export function observeAuth(observer: AuthObserver): Unsubscribe {
  return onAuthStateChanged(getFirebaseServices().auth, observer);
}

export async function signInWithGoogle(): Promise<User> {
  const provider = new GoogleAuthProvider();
  provider.setCustomParameters({ prompt: "select_account" });
  return (await signInWithPopup(getFirebaseServices().auth, provider)).user;
}

export async function signInWithApple(): Promise<User> {
  const provider = new OAuthProvider("apple.com");
  provider.addScope("email");
  provider.addScope("name");
  return (await signInWithPopup(getFirebaseServices().auth, provider)).user;
}

export async function signInWithEmail(email: string, password: string): Promise<User> {
  return (await signInWithEmailAndPassword(getFirebaseServices().auth, email.trim(), password)).user;
}

export async function createEmailAccount(email: string, password: string): Promise<User> {
  return (await createUserWithEmailAndPassword(getFirebaseServices().auth, email.trim(), password)).user;
}

export async function resetEmailPassword(email: string): Promise<void> {
  await sendPasswordResetEmail(getFirebaseServices().auth, email.trim());
}

export async function signOutCurrentUser(): Promise<void> {
  await signOut(getFirebaseServices().auth);
}

